import { useTranslation } from "react-i18next";

import { Tooltip } from "@aviary/components/Tooltip";
import { l } from "@aviary/locales/i18n";

import type { AviaryAvatarSize } from "../Avatar.types";

import * as styles from "./PlatformBadge.styles";

interface Props {
  size?: AviaryAvatarSize;
  platform?: "wellevate" | "rupa";
}

const PlatformBadge = ({ size = "medium", platform = "wellevate" }: Props) => {
  const { t } = useTranslation();

  const badgeStyles = [styles.badge, styles.badgeSize[size]];
  const labelContent =
    platform === "wellevate" ? t(l.aviary.avatar.wellevateLabel) : t(l.aviary.avatar.rupaLabel);

  return (
    <Tooltip placement="bottom" tooltipContent={labelContent}>
      <div css={badgeStyles} aria-label={labelContent}>
        <span css={styles.fontSize[size]}>{platform === "wellevate" ? "W" : "R"}</span>
      </div>
    </Tooltip>
  );
};

export { PlatformBadge };
